const PageHeader = ({ title, subtitle, breadcrumbs, action, filters }) => {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div className="min-w-0">
        {breadcrumbs ? (
          <nav className="mb-1 text-xs text-gray-500">{breadcrumbs}</nav>
        ) : null}
        <h1 className="text-2xl font-bold text-navy-700 dark:text-white">
          {title}
        </h1>
        {subtitle ? (
          <p className="mt-1 text-sm text-gray-500">{subtitle}</p>
        ) : null}
      </div>
      <div className="flex flex-wrap items-center gap-3">
        {filters}
        {action}
      </div>
    </div>
  );
};

export default PageHeader;
